import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseCoreState, baseInquirySelectors, baseInquiryActions } from '../../_store';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BaseInquiryListPayloadInterface } from '../../modules/inquiry/_interfaces/base-inquiry-list-payload.interface';

@Injectable({ providedIn: 'root' })
export class BasePspInquiryListGuard {
  constructor(private store: Store<BaseCoreState>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.store.dispatch(
      baseInquiryActions.getPSPInquiries({
        payload: route.queryParams as BaseInquiryListPayloadInterface,
      })
    );

    return this.store.select(baseInquirySelectors.getInquiries).pipe(
      filter((result) => result.ok !== undefined),
      map((result) => !!result.ok)
    );
  }
}
